/**
 * What the call UI accepts as a meeting identifier (GH-1855).
 *
 * A real meeting is found only by its room id or its join code. The video
 * service still mints ad-hoc rooms for the office service's `office-<key>` /
 * `announce-<key>` names (homework calls them through `videoService.getRoom`
 * directly), but those are not meetings a user can open from the call UI.
 */

const OFFICE_ROOM_PREFIXES = ["office-", "announce-"];

/** An office/homework ad-hoc room name — "Meeting not found" in the call UI. */
export function isOfficeRoomIdentifier(identifier: string): boolean {
  const normalized = identifier.trim().toLowerCase();
  return OFFICE_ROOM_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

/** The video service answered "not found" (HTTP 404) for this identifier. */
export function isNotFoundError(error: unknown): boolean {
  return (error as { code?: number } | null | undefined)?.code === 404;
}
